var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m82.5 142.5v272c10.497-2.637 20.474-4.866 30-6.741l90-144.984-90-127.016c-9.526 1.875-19.503 4.104-30 6.741z",
    fill: "#fff5de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.5 142.5c-10.497 2.637-20.474 4.866-30 6.741l-90 132.629 90 139.371c9.526-1.875 19.503-4.104 30-6.741z",
    fill: "#c7e3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.5 135.759v272c168.645-33.192 193.355 46.674 362 13.483v-272c-168.645 33.191-193.355-46.675-362-13.483z",
    fill: "#e5f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5 67.5h30v437h-30z",
    fill: "#7aa3ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.5 52.5h-30v30h30c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#ffd478"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 67.5,
    fill: "#ffe7ad",
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 30,
    fill: "#ffd478",
    r: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.112 136.586c-1.823-1.421-4.199-1.923-6.439-1.36-101.619 25.53-153.007 13.121-207.412-.017-52.366-12.646-106.479-25.704-206.421-1.975-3.528-13.83-14.761-24.611-28.839-27.48v-17.044c8.729-3.096 15-11.432 15-21.21 0-8.977-5.287-16.74-12.908-20.348 3.402-4.865 5.407-10.777 5.407-17.152 0-16.542-13.458-30-30-30s-30 13.458-30 30c0 6.375 2.005 12.287 5.408 17.152-7.621 3.608-12.908 11.371-12.908 20.348 0 9.777 6.271 18.114 15 21.21v415.79c0 4.142 3.357 7.5 7.5 7.5h30c4.143 0 7.5-3.358 7.5-7.5v-53.255c15.17-3.092 27.033-15.371 29.515-30.751 98.194-23.822 148.753-11.616 202.224 1.296 31.123 7.516 62.857 15.179 104.466 15.179 30.286 0 65.805-4.061 110.122-15.195 3.335-.838 5.673-3.836 5.673-7.274v-272c0-2.311-1.065-4.493-2.888-5.914zm-456.612-61.586h-30c-4.136 0-7.5-3.364-7.5-7.5s3.364-7.5 7.5-7.5h30c4.136 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5zm-15-60c8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15 6.729-15 15-15zm7.5 482h-15v-407h15zm30-82.5c0 9.777-6.271 18.114-15 21.21v-314.42c8.729 3.096 15 11.432 15 21.21zm422-5.875c-97.874 23.666-148.356 11.476-201.739-1.415-46.647-11.264-94.682-22.856-175.261-8.481v-202.97c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v205.869c-4.884 1.016-9.881 2.124-15 3.329v-256.579c5.129-1.24 10.125-2.379 15-3.427v20.808c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-23.818c78.769-14.599 124.098-3.654 171.739 7.85 52.165 12.597 106.053 25.61 205.261 2.254z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.fd2d0c08f3e00ac2124bc72374bc36f2.svg";
export { ForwardRef as ReactComponent };